import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Unsubscribe'}),
    routes: [
        {
            path: '/users/unsubscribe/email/',
            component: () => import(/* webpackChunkName: "accountPages" */ './EmailUnsubscribePage.vue'),
            name: 'EmailUnsubscribePage',
        },
    ]
});
